import Swal from "sweetalert2";
import { CheckIcon, FileIcon, ImageIcon, MessageIcon, PdfIcon, RejectIcon, UploadIcon, XIcon } from "../Helper/Icons";
import { useEffect, useRef, useState } from "react";
import PlantillaScreen3 from "../../helpers/PlantillaScreen3";
import request from "../../../Helpers/API";

// ── Config estatus justificación ──────────────────────────────────────────────
const JUST_CONFIG = {
    P: { label: "Pendiente", dot: "#8d9688", bg: "#eef0ec", text: "#4f5a4b", border: "#d5d9d0" },
    J: { label: "Justificado", dot: "#0891b2", bg: "#e0f7fa", text: "#065f70", border: "#67d4e8" },
    A: { label: "Aceptado", dot: "#639922", bg: "#eaf3de", text: "#27500a", border: "#97c459" },
    X: { label: "Revisión", dot: "#d97706", bg: "#fff8e1", text: "#7c4a00", border: "#fbbf24" }, // ámbar — aceptación parcial
    R: { label: "Rechazado", dot: "#e24b4a", bg: "#fcebeb", text: "#791f1f", border: "#f09595" },
};

// ── Modal de detalle / justificación ─────────────────────────────────────────
export const DetalleModal = ({
    item,
    onClose,
    onGuardar,
    onAceptar,
    onRechazar,
    esAuditor,
    esEncargado,
    loading,
}) => {

    const [comentario, setComentario] = useState(item?.estatus_just === "X" ? "" : (item?.comentario_usuario ?? ""));
    const [archivos, setArchivos] = useState([]);
    const [motivoRechazo, setMotivoRechazo] = useState("");
    const [showRechazo, setShowRechazo] = useState(false);
    const fileRef = useRef(null);

    // Estados nuevos para aceptación parcial
    const [tipoAceptacion, setTipoAceptacion] = useState("total"); // "total" | "parcial"
    const [cantidadAceptada, setCantidadAceptada] = useState(0);

    //Archivos cargados para revision
    const [loader, setLoader] = useState(false);

    const [archivosCargados, setArchivosCargados] = useState([]);

    // Calcular pendientes reales (diferencia total menos lo ya aceptado)
    const pendienteReal = Math.abs(item.diferencia) - (item.aceptadas ?? 0);


    // ← Mover el request aquí, se ejecuta UNA SOLA VEZ al montar el modal
    useEffect(() => {
        if (!item?.id_just) return;
        setLoader(true);
        request
            .get(`AuditoriaJustificaciones/obtenerArchivos?idjust=${item.id_just}`)
            .then(result => setArchivosCargados(result ?? []))
            .catch(err => Swal.fire("JUSTIFICACIONES", JSON.stringify(err), "error"))
            .finally(() => setLoader(false));
    }, [item?.id_just]); // ← solo se re-ejecuta si cambia el id_just

    // ← Early return DESPUÉS de todos los hooks
    if (!item) return null;

    const cfg = JUST_CONFIG[item.estatus_just] ?? JUST_CONFIG["P"];

    const handleFile = (e) => {
        const files = Array.from(e.target.files);
        setArchivos(prev => [...prev, ...files]);
    };

    const removeArchivo = (i) => setArchivos(prev => prev.filter((_, idx) => idx !== i));

    const handleGuardar = () => {
        if (!esEncargado && !esAuditor) {
            Swal.fire("JUSTIFICACIONES", "Solo el encargado de almacen puede subir documientación", "error");
            return;
        }
        onGuardar?.({ idconteo: item.id_conteo, idjust: item.id_just, comentario, archivos });
    };

    const handleRechazar = () => {
        if (!motivoRechazo.trim()) {
            Swal.fire("JUSTIFICACIONES", "Debe ingresar el motivo del rechazo", "warning");
            return;
        }
        onRechazar?.({ folio: item.folio, idjust: item.id_just, motivo: motivoRechazo });
    };

    const handleBackdropClick = (e) => {
        if (e.target === e.currentTarget) onClose?.();
    };

    const descargarArchivo = (rutaServidor, nombreArchivo, tipoArchivo) => {
        setLoader(true);
        request
            .getBlob(`AuditoriaJustificaciones/DescargarArchivos?ruta=${rutaServidor}&nombre=${nombreArchivo}&extension=${tipoArchivo}`)
            .then((blob) => {
                const url = URL.createObjectURL(blob);
                const link = document.createElement("a");
                link.href = url;
                link.download = nombreArchivo;
                link.click();
                URL.revokeObjectURL(url);
            })
            .catch((error) => {
                Swal.fire("JUSTIFICACIONES", JSON.stringify(error), "error");
            })
            .finally(() => setLoader(false));

    };

    // const eliminarArchivo = (idEvidencia, nombreArchivo) => {
    //     Swal.fire({
    //         title: "¿Eliminar evidencia?",
    //         text: `Se eliminará "${nombreArchivo}" permanentemente.`,
    //         icon: "warning",
    //         showCancelButton: true,
    //         confirmButtonText: "Sí, eliminar",
    //         cancelButtonText: "Cancelar",
    //         confirmButtonColor: "#d33",
    //     }).then(result => {
    //         if (result.isConfirmed) {
    //             // Llama al padre para manejar la eliminación
    //             onEliminarArchivo?.({ id_evidencia: idEvidencia });
    //         }
    //     });
    // };
    // console.log(archivos)
    return (
        <div className="jd-backdrop" onClick={handleBackdropClick}>
            <PlantillaScreen3
                titulo={"Justificación de discrepancia"}
                className={"jd-modal ram-modal"}
            >

                <button className="ram-close" onClick={onClose} type="button">X</button>

                <div className="jd-modal__subheader">
                    <span className="jd-modal__eyebrow">
                        {item.modelo} — {item.descripcion}
                    </span>
                    <span
                        className="jd-badge"
                        style={{ background: cfg.bg, color: cfg.text, borderColor: cfg.border }}
                    >
                        <span className="jd-badge__dot" style={{ background: cfg.dot }} />
                        {cfg.label}
                    </span>
                </div>

                {/* Info de la discrepancia */}
                <div className="jd-modal__info-strip">
                    <div className="jd-info-item">
                        <span className="jd-info-item__label">Sistema</span>
                        <span className="jd-info-item__value">{item.cant_sistema}</span>
                    </div>
                    <div className="jd-info-item">
                        <span className="jd-info-item__label">Físico</span>
                        <span className="jd-info-item__value">{item.cant_fisica}</span>
                    </div>
                    <div className="jd-info-item jd-info-item--diff">
                        <span className="jd-info-item__label">Diferencia</span>
                        <span className="jd-info-item__value">{item.diferencia > 0 ? `+${item.diferencia}` : item.diferencia}</span>
                    </div>
                    <div className="jd-info-item">
                        <span className="jd-info-item__label">Categoría</span>
                        <span className="jd-info-item__value">{item.categoria}</span>
                    </div>
                    <div className="jd-info-item">
                        <span className="jd-info-item__label">Ubicación</span>
                        <span className="jd-info-item__value">{item.ubicacion ?? "—"}</span>
                    </div>
                </div>

                {/* Body */}
                <div className="jd-modal__body">

                    {/* Comentario del usuario */}
                    <div className="jd-modal__section">
                        <label className="jd-modal__section-label">
                            <MessageIcon /> Comentario / justificación
                        </label>
                        <textarea
                            className="jd-modal__textarea"
                            placeholder="Describe el motivo de la discrepancia..."
                            value={comentario}
                            onChange={e => setComentario(e.target.value)}
                            disabled={esAuditor || item.estatus_just === "A"}
                            rows={4}
                        />
                    </div>

                    {/* Archivos existentes */}
                    {(archivosCargados ?? []).length > 0 && (
                        <div className="jd-modal__section">
                            <label className="jd-modal__section-label">
                                <FileIcon /> Documentos cargados
                            </label>
                            <div className="jd-files-list">
                                {archivosCargados.map((arch, i) => (
                                    <div
                                        key={i}
                                        className="jd-file-chip"
                                        style={{ cursor: "pointer" }}
                                        onClick={() => descargarArchivo(arch.ruta_servidor, arch.nombre_archivo, arch.tipo_archivo)}
                                    >
                                        {/* Ícono según tipo de archivo */}
                                        {["jpg", "jpeg", "png"].includes(arch.tipo_archivo?.toLowerCase())
                                            ? <ImageIcon />
                                            : arch.tipo_archivo?.toLowerCase() === "pdf"
                                                ? <PdfIcon />
                                                : <FileIcon />
                                        }
                                        <span>{arch.nombre_archivo}</span>

                                        {/* Botón eliminar — solo si no está aceptado y no es auditor */}
                                        {!esAuditor && (item.estatus_just !== "A" || item.estatus_just !== "X") && (
                                            <button
                                                type="button"
                                                className="jd-file-chip__remove"
                                                title="Eliminar archivo"
                                            // onClick={(e) => {
                                            //     e.stopPropagation();
                                            //     eliminarArchivo(arch.id, arch.nombre_archivo);
                                            // }}
                                            >
                                                <XIcon />
                                            </button>
                                        )}
                                    </div>
                                ))}
                            </div>
                        </div>
                    )}

                    {/* Upload — solo si no es auditor y no está aceptado */}
                    {!esAuditor && (item.estatus_just !== "A" || item.estatus_just === "X") && (
                        <div className="jd-modal__section">
                            <label className="jd-modal__section-label">
                                <UploadIcon /> Adjuntar evidencia
                            </label>
                            <div
                                className="jd-dropzone"
                                onClick={() => fileRef.current?.click()}
                            >
                                <UploadIcon />
                                <span>Haz click o arrastra archivos aquí</span>
                                <span className="jd-dropzone__sub">PDF, JPG, PNG, EXCEL, WORD — máx. 10 MB</span>
                            </div>
                            <input
                                ref={fileRef}
                                type="file"
                                multiple
                                accept=".pdf,.jpg,.jpeg,.png,.xlsx,.docx"
                                style={{ display: "none" }}
                                onChange={handleFile}
                            />
                            {archivos.length > 0 && (
                                <div className="jd-files-list" style={{ marginTop: "0.5rem" }}>
                                    {archivos.map((f, i) => (
                                        <div key={i} className="jd-file-chip jd-file-chip--new">
                                            <FileIcon />
                                            <span>{f.name}</span>
                                            <button
                                                type="button"
                                                className="jd-file-chip__remove"
                                                onClick={(e) => { e.stopPropagation(); removeArchivo(i); }}
                                            >
                                                <XIcon />
                                            </button>
                                        </div>
                                    ))}
                                </div>
                            )}
                        </div>
                    )}

                    {/* Comentario del auditor (rechazo) */}
                    {item.motivo_rechazo && (
                        <div className="jd-modal__section">
                            <label className="jd-modal__section-label jd-modal__section-label--reject">
                                <RejectIcon /> Motivo de rechazo
                            </label>
                            <div className="jd-reject-note">{item.motivo_rechazo}</div>
                        </div>
                    )}

                    {/* Aceptación parcial */}
                    {item.estatus_just === "X" && (
                        <div className="jd-modal__section">
                            <label className="jd-modal__section-label jd-modal__section-label--parcial">
                                <CheckIcon /> Aceptación parcial
                            </label>
                            <div className="jd-parcial-note">
                                Se aceptaron <b>{item.aceptadas}</b> de <b>{Math.abs(item.diferencia)}</b> diferencias.
                                Quedan <b>{Math.abs(item.diferencia) - (item.aceptadas ?? 0)}</b> pendientes por justificar.
                            </div>
                        </div>
                    )}


                    {/* Panel de rechazo (auditor) */}
                    {esAuditor && showRechazo && (
                        <div className="jd-modal__section">
                            <label className="jd-modal__section-label jd-modal__section-label--reject">
                                <RejectIcon /> Motivo del rechazo
                            </label>
                            <textarea
                                className="jd-modal__textarea jd-modal__textarea--reject"
                                placeholder="Explica por qué se rechaza esta justificación..."
                                value={motivoRechazo}
                                onChange={e => setMotivoRechazo(e.target.value)}
                                rows={3}
                            />
                        </div>
                    )}
                </div>

                {/* Body — agregar ANTES del panel de rechazo */}

                {/* Panel de aceptación parcial (auditor) */}
                {esAuditor && item.estatus_just === "J" && !showRechazo && (
                    <div className="jd-modal__section">
                        <label className="jd-modal__section-label">
                            <CheckIcon /> Tipo de aceptación
                        </label>

                        {/* Toggle total / parcial */}
                        <div className="jd-accept-toggle">
                            <button
                                type="button"
                                className={`jd-accept-toggle__btn ${tipoAceptacion === "total" ? "active" : ""}`}
                                onClick={() => setTipoAceptacion("total")}
                            >
                                <CheckIcon /> Aceptar todo ({pendienteReal})
                            </button>
                            <button
                                type="button"
                                className={`jd-accept-toggle__btn ${tipoAceptacion === "parcial" ? "active--parcial" : ""}`}
                                onClick={() => setTipoAceptacion("parcial")}
                            >
                                Aceptación parcial
                            </button>
                        </div>

                        {/* Input de cantidad — solo si parcial */}
                        {tipoAceptacion === "parcial" && (
                            <div className="jd-parcial-wrap">
                                <label className="jd-parcial-wrap__label">
                                    Cantidad a aceptar (máx. {pendienteReal})
                                </label>
                                <div className="jd-parcial-wrap__input-wrap">
                                    <button
                                        type="button"
                                        className="jd-parcial-wrap__btn"
                                        onClick={() => setCantidadAceptada(p => Math.max(0, p - 1))}
                                    >−</button>
                                    <input
                                        type="number"
                                        className="jd-parcial-wrap__input"
                                        min={0}
                                        max={pendienteReal}
                                        value={cantidadAceptada}
                                        onChange={e => {
                                            const v = Math.min(pendienteReal, Math.max(0, Number(e.target.value)));
                                            setCantidadAceptada(v);
                                        }}
                                    />
                                    <button
                                        type="button"
                                        className="jd-parcial-wrap__btn"
                                        onClick={() => setCantidadAceptada(p => Math.min(pendienteReal, p + 1))}
                                    >+</button>
                                </div>
                                <span className="jd-parcial-wrap__hint">
                                    Pendiente por justificar: <b>{pendienteReal - cantidadAceptada}</b>
                                </span>
                            </div>
                        )}
                    </div>
                )}

                {/* Footer */}
                <div className="jd-modal__footer">

                    {/* Acciones del auditor */}
                    {esAuditor && (item.estatus_just === "J" || item.estatus_just === "P" ) && (
                        <>
                            {!showRechazo ? (
                                <>

                                    <button
                                        type="button"
                                        className="jd-btn jd-btn--reject"
                                        onClick={() => setShowRechazo(true)}
                                        disabled={loading}
                                    >
                                        <RejectIcon /> Rechazar
                                    </button>
                                    <button
                                        type="button"
                                        className="jd-btn jd-btn--accept"
                                        disabled={loading || (tipoAceptacion === "parcial" && cantidadAceptada === 0)}
                                        onClick={() => onAceptar?.({
                                            folio: item.folio,
                                            idjust: item.id_just,
                                            tipo_aceptacion: tipoAceptacion,
                                            cantidad_aceptada: tipoAceptacion === "total"
                                                ? pendienteReal
                                                : cantidadAceptada,
                                        })}
                                    >
                                        <CheckIcon />
                                        {tipoAceptacion === "total"
                                            ? "Aceptar todo"
                                            : `Aceptar ${cantidadAceptada}`}
                                    </button>
                                </>
                            ) : (
                                <>
                                    <button
                                        type="button"
                                        className="jd-btn jd-btn--ghost"
                                        onClick={() => setShowRechazo(false)}
                                    >
                                        Cancelar
                                    </button>
                                    <button
                                        type="button"
                                        className="jd-btn jd-btn--reject"
                                        onClick={handleRechazar}
                                        disabled={loading}
                                    >
                                        {loading ? <span className="jd-btn__spinner" /> : <RejectIcon />}
                                        Confirmar rechazo
                                    </button>
                                </>
                            )}
                        </>
                    )}

                    {/* Acción del usuario — guardar justificación */}
                    {!esAuditor && (item.estatus_just !== "A" || item.estatus_just !== "X") && (
                        <button
                            type="button"
                            className="jd-btn jd-btn--primary"
                            onClick={handleGuardar}
                            disabled={loading || (!comentario.trim() && archivos.length === 0)}
                        >
                            {loading ? <span className="jd-btn__spinner" /> : <CheckIcon />}
                            {loading ? "Guardando..." : "Guardar justificación"}
                        </button>
                    )}
                </div>
            </PlantillaScreen3>
        </div >
    );
};